import React, { Component } from 'react'
import { Notice, Button, HelpEmail } from 'components'
import { AnalyticsUtils } from 'utils'

export default class GenericError extends React.Component {
  static propTypes = {
    user: React.PropTypes.object.isRequired,
    onRefresh: React.PropTypes.func.isRequired
  }

  componentWillMount() {
    AnalyticsUtils.searchConsoleErrorViewed(this.props.user.email, "generic")
  }

  body() {
    return (
      <div>
        <p>An unexpected error occured, refresh to try again.</p>
        <p className="small-spacing--top">If the error persists contact us at <HelpEmail /></p>
        <div className="medium-spacing--top">
          <Button
            label="Refresh and try again"
            buttonType="primary"
            onTouchTap={::this.props.onRefresh}
          />
        </div>
      </div>
    )
  }

  render() {
    return <Notice 
      error={true}
      header="Cannot Connect to Search Console"
      note={this.body()}
      className="xlarge-spacing2--bottom"
    />
  }
}



// WEBPACK FOOTER //
// ./app/components/search_console/partials/GenericError.js